// extracted by mini-css-extract-plugin
export default {"container":"PractitionerSelector_container__jawZ8"};